import React,{Component} from "react"
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import ImageSlider from "./ImageSlider"; // This only needs to be imported once in your app
import OwlCarousel from "react-owl-carousel";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

class ProfileGallery extends Component{
    state = {
        photoIndex: 0,
        galleryIsOpen: false,
    };
    handleOpenGallery = (e, index) => {
        e.preventDefault();
        this.setState({
            galleryIsOpen: true,
            photoIndex: index,
        })
    };
    render(){
        const {galleryIsOpen, photoIndex} = this.state;

        const imagesSlider = this.props.imagesList && this.props.imagesList.length ? this.props.imagesList.map((image, index) => {
            return (
                <ImageSlider key={index} handleOpenGallery={(e) => this.handleOpenGallery(e, index)} index={index} image={image.image}/>
            )
        }) : null;

        let images = [];
        if(this.props.imagesList && this.props.imagesList.length){
          for(let i = 0; i<this.props.imagesList.length; i++ ){
              images = [...images, this.props.imagesList[i].image];
          }
        }

        return(
            <div className="row mb-40">
                {galleryIsOpen && (
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => this.setState({galleryIsOpen: false})}
                        onMovePrevRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + images.length - 1) % images.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + 1) % images.length,
                            })
                        }
                    />
                )}
                <OwlCarousel
                    className="owl-theme"
                    loop={false}
                    slideBy={3}
                    margin={40}
                    dots={true}
                    autoplay={true}
                    lazyLoad={true}
                    rtlClass={this.props.language === "ar" ? 'owl-rtl' : 'owl-ltr'}
                    responsive={{
                        0: {
                            items: 1
                        },
                        600: {
                            items: 2
                        },
                        1000: {
                            items: 3
                        }
                    }}>
                {imagesSlider}
                </OwlCarousel>
            </div>
        )
    }
}
export default ProfileGallery